// JS calculo de cantidades en precios de la vsiat carrito despues de hacer cambios en cantidad de producto para carritos con apps de descuentos WHOLESALE

$(document).ready(function(){
    // variantes
    let total = 0
    let total_pop = 0
    let cart

    // acciones
    $('body').on('click', '.js-cart-total-app__action', function(event) {
        cartTotalApp()
        cartTotalAppPrint()
    })

    $('body').on('change', '.js-cart-total-app__action-input', function(event) {
        cartTotalApp()
        cartTotalAppPrint()
    })

    // funciones
    function cartTotalApp() {
        cart = JSON.parse(localStorage.atom_cart)
        total = 0
        total_pop = 0
    }

    function cartTotalAppPrint() {
        const formatter = new Intl.NumberFormat('en-US', {
            currency: 'USD',
            minimumFractionDigits: 2
        })

        $('.js-cart-total-app__count').each( function (){
            $(this).html(cart.item_count)
        })

        $('.js-cart-total-app__line').each( function (){
            cart.items.forEach(item => {
                if ( $(this).data('cart-total-app__id') == item.id) {
                    $(this).html(`$ ${ formatter.format( Math.ceil($(this).data('cart-total-app__price')) * item.quantity / 100 )}`)
                    
                    total += Math.ceil($(this).data('cart-total-app__price')) * item.quantity
                }
            })
        })

        $('.js-cart-total-app__line-pop').each( function (){
            cart.items.forEach(item => {
                if ( $(this).data('cart-total-app__id') == item.id) {
                    $(this).html(`$ ${ formatter.format( Math.ceil($(this).data('cart-total-app__price')) * item.quantity / 100 )}`)
                    
                    total_pop += Math.ceil($(this).data('cart-total-app__price')) * item.quantity
                }
            })
        })

        $('.js-cart-total-app__total').each( function (){
            $(this).html(`$ ${formatter.format(total/100)}`)
        })

        $('.js-cart-total-app__total-pop').each( function (){
            $(this).html(`$ ${formatter.format(total_pop/100)}`)
        })
    }
})